import React from "react";
import ReactDOM from "react-dom";
import Application from "./application";

ReactDOM.render(
    <React.StrictMode>
        <Application />
    </React.StrictMode>,
    document.getElementById("root")
);
